import { TextFieldProps } from '@mui/material/TextField';
import { PasswordInput } from 'components/@shared/PasswordInput/PasswordInput';
import { useField } from 'formik';

interface Props extends Omit<TextFieldProps, 'name'> {
    name: string;
}
export const FormPasswordInput = ({ name, onChange, onBlur, ...props }: Props) => {
    const [field, meta] = useField({ name, onChange, onBlur });

    return (
        <PasswordInput
            {...props}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
            {...field}
        />
    );
};
